import React from "react";

interface ButtonProps {
  title: string;
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({
  title,
  onPress,
  disabled = false,
  loading = false,
  className = "",
}) => {
  const isDisabled = disabled || loading;

  return (
    <button
      type="button"
      onClick={onPress}
      disabled={isDisabled}
      className={`flex h-11 w-full items-center justify-center bg-xcf-purple font-oswald text-[17px] font-medium text-white transition-opacity hover:opacity-90 active:opacity-80 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
    >
      {loading ? (
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent" />
      ) : (
        title
      )}
    </button>
  );
};
